import { IProject } from '../../models/IProject';
import { IScript } from '../../models/IScript';

function getScriptByScriptName(scriptName: string, project: IProject): IScript {
    let script = {} as IScript;

    if (project.scripts) {
        for (let i = 0; i < project.scripts.length; i++) {
            if (project.scripts[i].name === scriptName) {
                script = project.scripts[i];
                break;
            }
        }
    }

    return script;
}

export default getScriptByScriptName;
